import { DropdownItem } from '@komi-app/creator-ui'
import { PhoneNumberFilter, CountryCodeFilter } from '@komi-app/messaging-sdk'

export const filterOptions: DropdownItem[] = [
  {
    value: PhoneNumberFilter.Contains,
    label: 'Contains'
  },
  {
    value: PhoneNumberFilter.StartsWith,
    label: 'Starting'
  },
  {
    value: PhoneNumberFilter.EndsWith,
    label: 'Ending'
  }
]

export const countriesOptions: DropdownItem[] = [
  {
    label: 'United States of America',
    value: CountryCodeFilter.US,
    suffixTagProps: {
      variant: 'brand',
      text: '+1'
    }
  },
  {
    label: 'Canada',
    value: CountryCodeFilter.CA,
    suffixTagProps: {
      variant: 'brand',
      text: '+1'
    }
  }
]
